import * as React from 'react';

const QuestionCircle16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 1.5A6.5 6.5 0 1 1 1.5 8 6.51 6.51 0 0 1 8 1.5ZM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M8 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm.75-.88h-1.5v-.79a2.17 2.17 0 0 1 1.18-2A1 1 0 0 0 9 5.7a1 1 0 0 0-.72-.7 1 1 0 0 0-1.186.538A1 1 0 0 0 7 6H5.5a2.5 2.5 0 1 1 3.59 2.25.66.66 0 0 0-.34.61v.76Z"
  }
));
QuestionCircle16.Size = 16;
QuestionCircle16.Title = "QuestionCircle";

export { QuestionCircle16 as default };
